import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import './Investor.css';

const Investor = () => {
    const [brand, setBrand] = useState('');
    const [description, setDescription] = useState('');
    const [wp, setWp] = useState('');
    const [nomenclature, setNomenclature] = useState('');
    const [price, setPrice] = useState('');
    const navigate = useNavigate();

    const handleAddInvestor = async (e) => {
        e.preventDefault();

        if (brand && description && wp && nomenclature && price) {
            const newInvestor = {
                Marca: brand,
                Description: description,
                Wp: Number(wp),
                Nomenclatura: nomenclature,
                Price: parseFloat(price),
            };

            try {
                await addDoc(collection(db, 'Inversores'), newInvestor);
                Swal.fire({
                    title: 'Éxito',
                    text: 'Inversor registrado con éxito.',
                });
                setBrand('');
                setDescription('');
                setWp('');
                setNomenclature('');
                setPrice('');
                navigate('/admin/inversores/settings');
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    text: 'Ocurrió un error al registrar el inversor.',
                });
            }
        } else {
            Swal.fire({
                title: 'Error',
                text: 'Todos los campos son obligatorios.',
            });
        }
    };

    return (
        <div className="investor-container">
            <h1 className="investor-title">Registrar Inversor</h1>
            <form className="investor-form" onSubmit={handleAddInvestor}>
                <label className="label-investor">
                    Marca
                    <input
                        className="input-investor"
                        type="text"
                        value={brand}
                        onChange={(e) => setBrand(e.target.value)}
                        required
                    />
                </label>
                <label className="label-investor">
                    Descripción
                    <textarea
                        className="textarea-investor"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                    />
                </label>
                <div className="input-row-investor">
                <label className="label-investor">
                    Wp
                    <input
                        className="input-investor"
                        type="number"
                        value={wp}
                        onChange={(e) => setWp(e.target.value)}
                        required
                    />
                </label>
                <label className="label-investor">
                    Nomenclatura
                    <input
                        className="input-investor"
                        type="text"
                        value={nomenclature}
                        onChange={(e) => setNomenclature(e.target.value)}
                        required
                    />
                </label>
                <label className="label-investor">
                    Precio
                    <input
                        className="input-investor"
                        type="number"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        required
                    />
                </label>
                </div>
                <div className="investor-btn-container">
                    <button className="btn-investor" type="submit">Agregar Inversor</button>
                    <button className="btn-investor" onClick={() => navigate('/admin/inversores/settings')}>Cancelar</button>
                </div>
            </form>
        </div>
    );
};

export default Investor;